import React from 'react';
import {gql, useQuery} from "@apollo/client/index";

const REQUEST = gql`
  query {
        getWarmUp {
            discountMinorUnits
            code
            expiresInSeconds
            images {
                image
                url
            }
        }
  }
`;
export default function WarmUpRequest(props) {

    const { error, data } = useQuery(REQUEST);

    if (error) {
        props.onError(error);
    }

    if (data) {
        props.onData(data.getWarmUp);
    }

    return null;
}
